export default __webpack_public_path__ + "static/media/back.f08ad78a.svg";